import React from 'react'
import '../../stylesheet/components/structure/SectionBody.scss'

const SectionBody: React.FC<{ children?: JSX.Element | JSX.Element[] }> = ({ children }) => {
    return <div className="container main">
        {children}
    </div>
}

export default SectionBody
